/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, inject } from '@angular/core';
import { CDS_POPUP_DATA, MatDialogRef } from '../cd-popup.service';
import { CdPopupComponent } from '../cd-popup/cd-popup.component';
import { CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-cd-popup-delete',
  templateUrl: './cd-popup-delete.component.html',
  styleUrls: ['./cd-popup-delete.component.scss'],
  imports: [CdPopupComponent, CdsPopupModule, CdsButtonModule, CdsLanguageModule],
})
export class CdPopupDeleteComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<CdPopupDeleteComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    message: string;
    subMessage: string;
    params: any;
  }>(CDS_POPUP_DATA);

  ngOnInit() {}

  cancle() {
    this.dialogRef.close({ delete: false });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }
}
